import React from 'react';
import { Box, Radio, Stack, Typography } from '@mui/material';
import { useCurrentStateByControlUnitId } from '../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import { getPolyglot } from '../../../i18n';

interface StatusProps {
  value: boolean | undefined;
  icon: React.ReactElement;
  name?: string;
  deviceId: string;
  controlUnitId: string;
  actionId: string;
  CUTranslate: ReturnType<typeof useCurrentStateByControlUnitId>['CUTranslate'];
  switchColors?: {
    thumbColorOn?: string;
    thumbColorOff?: string;
    trackColorOn: string;
    trackColorOff?: string;
    iconColor?: string;
    buttonColor?: string;
  };
  isDeviceConnected?: boolean;
  isDeviceOn?: boolean;
}
function ModeOven(props: StatusProps) {
  const polyglot = getPolyglot();
  const {
    value,
    name,
    icon,
    actionId,
    CUTranslate,
    isDeviceConnected,
    isDeviceOn,
  } = props;

  const internalTranslation = polyglot.t(`device.actions.${actionId}`, {
    _: actionId,
  });
  const translation = (CUTranslate(actionId) as string) || internalTranslation;
  const actionName = name || translation;

  return (
    <Stack spacing={0.5} direction={'column'} alignItems={'center'}>
      <Box
        sx={{
          flexDirection: 'column',
          opacity: isDeviceOn ? 1 : !isDeviceConnected ? 0.5 : 0.7,
        }}
      >
        <Box
          sx={{
            fontSize: '1.5em',
            display: 'flex',
            color:
              value && isDeviceConnected
                ? (theme) => theme.palette.primary.main
                : (theme) => theme.palette.text.disabled,
            justifyContent: 'center',
            alignItems: 'center',
          }}
          padding={0.2}
        >
          {icon}
          <Typography fontSize={'0.6rem'} margin={'0.2rem'}>
            {actionName}
          </Typography>
          {isDeviceConnected ? (
            <Radio
              checked={value}
              disabled={!isDeviceConnected}
              sx={{ padding: '0.2rem 0' }}
            />
          ) : null}
        </Box>
      </Box>
    </Stack>
  );
}

export default ModeOven;
